export enum RoleEnum {
    Student = "Student",
    Trainer = "Trainer",
    Administrator = "Administrator",
    CompanyManager = "CompanyManager"
}